<template>
    <div>
        <div v-if="summary" class="reports-summary mx-4">
            <div class="reports-summary-wrap m-0 row">
                <v-col cols="12" sm="6" md="6" xl="auto" class="reports-summary-col">
                    <div class="reports-summary-card extend">
                        <div class="reports-summary-card-icon">
                            <v-progress-circular
                                :size="56"
                                :width="6"
                                :rotate="270"
                                :value="patientsAddedTodayInPercent.value"
                                color="primary"
                            >
                                <span class="label" v-html="`${patientsAddedTodayInPercent.string}%`"></span>
                            </v-progress-circular>
                        </div>
                        <div class="reports-summary-card-wrap">
                            <div class="reports-summary-card-title">
                                <p>{{ t('reports::summary.newly_added') }}</p>
                            </div>
                            <div class="reports-summary-card-sub-title">
                                <p>
                                    <v-tooltip top transition="v-fab-transition">
                                        <template #activator="{ on, attrs }">
                                            <span v-bind="attrs" v-on="on">
                                                {{ summary.newly_added }}
                                            </span>
                                        </template>
                                        <span>{{
                                            t('reports::summary.hint.all_patients_added_for_the_chosen_period')
                                        }}</span>
                                    </v-tooltip>
                                    <v-tooltip top transition="v-fab-transition">
                                        <template #activator="{ on, attrs }">
                                            <span v-bind="attrs" class="small" v-on="on">
                                                /&nbsp;&nbsp;{{ summary.total_active }}
                                            </span>
                                        </template>
                                        <span>{{ t('reports::summary.hint.all_patients') }}</span>
                                    </v-tooltip>
                                </p>
                            </div>
                        </div>
                    </div>
                </v-col>
                <v-col cols="12" sm="6" md="6" xl="auto" class="reports-summary-col"
                    ><div class="reports-summary-card overdue" @click="$emit('setDataTableFromSummary', 'overdue')">
                        <div class="reports-summary-card-icon">
                            <v-icon>mdi-account-arrow-right-outline</v-icon>
                        </div>
                        <div class="reports-summary-card-wrap">
                            <div class="reports-summary-card-title">
                                <p v-html="t('reports::summary.overdue_patients')"></p>
                            </div>
                            <div class="reports-summary-card-sub-title">
                                <p>
                                    <span>{{ summary.overdue }}</span>
                                </p>
                            </div>
                        </div>
                    </div>
                </v-col>
                <v-col cols="12" sm="6" md="4" xl="auto" class="reports-summary-col"
                    ><div
                        class="reports-summary-card max_dispensing"
                        @click="$emit('setDataTableFromSummary', 'max_dispensing')"
                    >
                        <div class="reports-summary-card-icon">
                            <v-icon>mdi-account-arrow-right-outline</v-icon>
                        </div>
                        <div class="reports-summary-card-wrap">
                            <div class="reports-summary-card-title">
                                <p v-html="t('reports::summary.max_dispensing')"></p>
                            </div>
                            <div class="reports-summary-card-sub-title">
                                <p>
                                    <span>{{ summary.max_dispensing }}</span>
                                </p>
                            </div>
                        </div>
                    </div>
                </v-col>
                <v-col cols="12" sm="6" md="4" xl="auto" class="reports-summary-col"
                    ><div
                        class="reports-summary-card due_for_the_week"
                        @click="$emit('setDataTableFromSummary', 'due_for_the_week')"
                    >
                        <div class="reports-summary-card-icon">
                            <v-icon>mdi-account-alert-outline</v-icon>
                        </div>
                        <div class="reports-summary-card-wrap">
                            <div class="reports-summary-card-title">
                                <p v-html="t('reports::summary.due_for_the_week')"></p>
                            </div>
                            <div class="reports-summary-card-sub-title">
                                <p>
                                    <span>{{ summary.due_for_the_week }}</span>
                                </p>
                            </div>
                        </div>
                    </div>
                </v-col>
                <v-col cols="12" sm="6" md="4" xl="auto" class="reports-summary-col"
                    ><div
                        class="reports-summary-card newly_registered"
                        @click="$emit('setDataTableFromSummary', 'newly_registered')"
                    >
                        <div class="reports-summary-card-icon">
                            <v-icon>mdi-account-check-outline</v-icon>
                        </div>
                        <div class="reports-summary-card-wrap">
                            <div class="reports-summary-card-title">
                                <p v-html="t('reports::summary.newly_registered')"></p>
                            </div>
                            <div class="reports-summary-card-sub-title">
                                <p>
                                    <span>{{ summary.newly_registered }}</span>
                                </p>
                            </div>
                        </div>
                    </div>
                </v-col>
                <v-col cols="12" sm="6" md="4" xl="auto" class="reports-summary-col"
                    ><div
                        class="reports-summary-card newly_restarted"
                        @click="$emit('setDataTableFromSummary', 'newly_restarted')"
                    >
                        <div class="reports-summary-card-icon">
                            <v-icon>mdi-account-cancel-outline</v-icon>
                        </div>
                        <div class="reports-summary-card-wrap">
                            <div class="reports-summary-card-title">
                                <p v-html="t('reports::summary.newly_restarted')"></p>
                            </div>
                            <div class="reports-summary-card-sub-title">
                                <p>
                                    <span>{{ summary.newly_restarted }}</span>
                                </p>
                            </div>
                        </div>
                    </div>
                </v-col>
                <v-col cols="12" sm="6" md="4" xl="auto" class="reports-summary-col"
                    ><div
                        class="reports-summary-card newly_transferred"
                        @click="$emit('setDataTableFromSummary', 'newly_transferred')"
                    >
                        <div class="reports-summary-card-icon">
                            <v-icon>mdi-account-arrow-left-outline</v-icon>
                        </div>
                        <div class="reports-summary-card-wrap">
                            <div class="reports-summary-card-title">
                                <p v-html="t('reports::summary.newly_transferred')"></p>
                            </div>
                            <div class="reports-summary-card-sub-title">
                                <p>
                                    <span>{{ summary.newly_transferred }}</span>
                                </p>
                            </div>
                        </div>
                    </div>
                </v-col>
                <v-col cols="12" sm="6" md="4" xl="auto" class="reports-summary-col"
                    ><div
                        class="reports-summary-card newly_re_challenged"
                        @click="$emit('setDataTableFromSummary', 'newly_re_challenged')"
                    >
                        <div class="reports-summary-card-icon">
                            <v-icon>mdi-account-clock-outline</v-icon>
                        </div>
                        <div class="reports-summary-card-wrap">
                            <div class="reports-summary-card-title">
                                <p v-html="t('reports::summary.newly_re_challenged')"></p>
                            </div>
                            <div class="reports-summary-card-sub-title">
                                <p>
                                    <span>{{ summary.newly_re_challenged }}</span>
                                </p>
                            </div>
                        </div>
                    </div>
                </v-col>
                <v-col cols="12" sm="6" md="4" xl="auto" class="reports-summary-col">
                    <div
                        class="reports-summary-card"
                        @click="$root.goTo($root.route('blood-results.index', { operator: -1 }))"
                    >
                        <div class="reports-summary-card-icon">
                            <v-icon>mdi-water-alert-outline</v-icon>
                        </div>
                        <div class="reports-summary-card-wrap">
                            <div class="reports-summary-card-title">
                                <p>{{ t('reports::summary.unassigned_blood_results') }}</p>
                            </div>
                            <div class="reports-summary-card-sub-title">
                                <p>
                                    <span>{{ summary.unassigned_blood_results }}</span>
                                </p>
                            </div>
                        </div>
                    </div>
                </v-col>
                <v-col cols="12" sm="6" md="4" xl="auto" class="reports-summary-col">
                    <div
                        class="reports-summary-card all_patients"
                        @click="$emit('setDataTableFromSummary', 'all_patients')"
                    >
                        <div class="reports-summary-card-icon">
                            <v-icon>mdi-account-arrow-right-outline</v-icon>
                        </div>
                        <div class="reports-summary-card-wrap">
                            <div class="reports-summary-card-title">
                                <p>{{ t('reports::summary.all_patients') }}</p>
                            </div>
                            <div class="reports-summary-card-sub-title">
                                <p>
                                    <span>{{ summary.all_patients }}</span>
                                </p>
                            </div>
                        </div>
                    </div>
                </v-col>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'ReportSummaryComponent',
    props: {
        summary: {
            type: Object,
            required: true,
            default: () => {},
        },
    },
    data() {
        return {};
    },
    computed: {
        selectedPeriod() {
            return this.$store.state.reports.selectedPeriod;
        },
        selectedReportType() {
            return this.$store.state.reports.patientGrid.filters.report_type;
        },
        patientsAddedTodayInPercent() {
            return this.calcNewPatients(this.summary.newly_added, this.summary.total_active);
        },
    },
    watch: {
        selectedPeriod() {
            this.$store.dispatch('reports/fetchReportsSummary');
        },
        selectedReportType(type) {
            return this.setActiveClass(type);
        },
    },
    created() {},
    destroyed() {},
    mounted() {},
    methods: {
        setActiveClass(type) {
            const cards = this.$el.querySelectorAll(`.reports-summary-card`);
            cards.forEach((card) => {
                card.classList.remove('active');
            });
            const activeCard = this.$el.querySelector(`.reports-summary-card.${type}`);
            if (activeCard) {
                activeCard.classList.add('active');
            }
        },
        goTo(type) {
            if (!this.selectedPeriod && !this.selectedPeriod.period) {
                return;
            }
            let period = { period: 'day' };
            switch (this.selectedPeriod.period) {
                case 'day':
                    period = { period: 'day' };
                    break;
                case 'week':
                    period = { period: 'week' };
                    break;
                case 'month':
                    period = { period: 'month' };
                    break;
                case 'custom':
                    period = _.clone(this.selectedPeriod);
                    delete period.period;
                    break;
                default:
                    period = { period: 'day' };
                    break;
            }
            let report_type;
            switch (type) {
                case 'due_for_the_week':
                    report_type = 'due_for_the_week';
                    break;
                case 'newly_registered':
                    report_type = 'newly_registered';
                    break;
                case 'newly_restarted':
                    report_type = 'newly_restarted';
                    break;
                case 'newly_transferred':
                    report_type = 'newly_transferred';
                    break;
                case 'newly_re_challenged':
                    report_type = 'newly_re_challenged';
                    break;
                case 'max_dispensing':
                    report_type = 'max_dispensing';
                    break;
                case 'overdue':
                    report_type = 'overdue';
                    break;
                case 'all_patients':
                    report_type = 'all_patients';
                    break;

                default:
                    break;
            }
            return this.$root.goTo(route('patients.index', { report_type, ...period }));
        },
        calcNewPatients(newPatients, totalPatients) {
            if (newPatients === 0 || totalPatients === 0) {
                return {
                    value: 0,
                    string: 0,
                };
            }
            if (!newPatients || !totalPatients) {
                return false;
            }
            return {
                value: Number((newPatients / totalPatients) * 100),
                string: Number((newPatients / totalPatients) * 100).toFixed(),
            };
        },
    },
};
</script>
